import styled from "styled-components";
import { deviceSizeQuery } from "@motain/web-shared-hub/constants";

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #1a1a1a;
  padding: 1.625rem 2.125rem;
  min-width: 100%;
  margin-top: 2rem;
  border-radius: 1rem;

  @media all and ${deviceSizeQuery.tabletPortrait} {
    min-width: 21.5rem;
    margin-top: 0;
  }
`;
